import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const useRouterFilters = (columns) => {
	const location = useLocation();
	const [searchParams] = useSearchParams();
	const [filtersFromRouter, setFiltersFromRouter] = useState(null);

	useEffect(() => {
		if (!searchParams.has('modal')) {
			const filters =
				location?.state?.defaultFilters?.map(({ column, action, value }) => ({
					column: columns.find((c) => c.accessor === column.accessor),
					action,
					value
				})) || null;
			setFiltersFromRouter(filters);
		}
	}, [location?.state?.defaultFilters]);

	return filtersFromRouter;
};

export default useRouterFilters;
